import React from "react";
import cx from "clsx";
import styles from "./styles.module.scss";
import { useAppTranslation } from "../../../../../../i18n/useAppTranslation";
import { ListCollapseIcon } from "../../../../../../assets/Icons/ListCollapseIcon";
import { Button } from "../../../../../../shared/Button/Button";
import { CopyIcon2 } from "../../../../../../assets/Icons/CopyIcon2";
import { DeleteIcon } from "../../../../../../assets/Icons/DeleteIcon";
import { Select } from "../../../../../../shared/Select/Select";
import { useContext } from "../../context";
import { useWindowSize } from "../../../../../../utilities/hooks/useWindowSize";
import { BLOCK_FIELDS, MOBILE_BREAKPOINT } from "../../config";
import { SURVEY_TYPE } from "../../../../../../api/surveys/config";
import { Toggle } from "./shared/Toggle";
import { DEFAULT_BLOCK_CHOICES } from "../../context/useHandler";

const TYPE_OPTIONS = Object.values(SURVEY_TYPE).map((type) => ({
  label: type,
  value: type,
}));

export const Params = () => {
  const { tSettings: t } = useAppTranslation.Settings({ keyPrefix: "survey" });
  const { layout, blocks, previewAnswers } = useContext();
  const windowSize = useWindowSize();

  if (layout.preview.isFullView) {
    return null;
  }

  const focusedBlock = blocks.getCurrent();

  return (
    <div className={styles.root}>
      <div className={styles.header}>
        {(layout.params.isOpen || windowSize.width < MOBILE_BREAKPOINT) && (
          <b>{t("params.title")}</b>
        )}
        <button onClick={layout.params.toggle}>
          <ListCollapseIcon />
        </button>
      </div>
      <div
        className={cx(styles.actions, {
          [styles.actionsCollapsed]:
            !layout.params.isOpen && windowSize.width > MOBILE_BREAKPOINT,
          [styles.actionsInvisible]:
            windowSize.width < MOBILE_BREAKPOINT && !layout.params.isOpen,
        })}
      >
        <Button
          size="small"
          variant="text"
          onClick={() => blocks.duplicate(focusedBlock.id)}
        >
          <CopyIcon2 width="18px" />
        </Button>
        <Button
          size="small"
          variant="text"
          onClick={() => blocks.delete(focusedBlock.id)}
        >
          <DeleteIcon width="18px" />
        </Button>
      </div>
      {layout.params.isOpen && (
        <div className={styles.settings}>
          <Select
            options={TYPE_OPTIONS}
            value={TYPE_OPTIONS.find(
              (o) => o.value === focusedBlock[BLOCK_FIELDS.type],
            )}
            onChange={(option) => {
              blocks.update(focusedBlock.id, BLOCK_FIELDS.type, option.value);
              previewAnswers.remove(focusedBlock.id);
              blocks.update(
                focusedBlock.id,
                BLOCK_FIELDS.choices,
                DEFAULT_BLOCK_CHOICES,
              );
            }}
          />
          <Toggle blockFieldType={BLOCK_FIELDS.isRequired}>
            {t("params.required")}
          </Toggle>
          <Toggle
            blockFieldType={BLOCK_FIELDS.isDescriptionRequired}
            afterChange={() =>
              blocks.update(focusedBlock.id, BLOCK_FIELDS.description, "")
            }
          >
            {t("params.description")}
          </Toggle>
          {focusedBlock[BLOCK_FIELDS.type] === SURVEY_TYPE.scale && (
            <Toggle blockFieldType={BLOCK_FIELDS.commentsOnScale}>
              {t("params.comments_on_scale")}
            </Toggle>
          )}
        </div>
      )}
    </div>
  );
};
